import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import {
  DatasetOverviewComponent,
  DatasetSyncButtonComponent,
  FlamingoGridNgComponent,
} from '@mode/switch-views/feature-dataset-overview';
import { DatasetEditComponent } from '@mode/dataset/shell';
import { DatasetNoDataComponent } from '@mode/dataset/ui';
import { DataRetentionNoDataComponent } from '@mode/dataset/ui';

export const DowngradedSwitchViewsFeatureDatasetOverviewModule = angular
  .module('downgraded-switch-views-feature-dataset-overview', [])
  .directive('modeDatasetEdit', downgradeComponent({ component: DatasetEditComponent }))
  .directive('modeDatasetOverview', downgradeComponent({ component: DatasetOverviewComponent }))
  .directive('modeDatasetNoData', downgradeComponent({ component: DatasetNoDataComponent }))
  .directive('modeDataRetentionNoData', downgradeComponent({ component: DataRetentionNoDataComponent }))
  .directive('modeDatasetSyncButton', downgradeComponent({ component: DatasetSyncButtonComponent }))
  .directive('modeFlamingoGridNg', downgradeComponent({ component: FlamingoGridNgComponent })).name;
